<script>
import RelativeTime from '../RelativeTime/RelativeTime.vue';
import { mapGetters } from 'vuex';
import Moment from 'moment';
// + Implicit dependency on ./state/NextToPlay.js
// + Implicit dependency on plugins/vue-moment.js

const TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ';

export default {
  components: {
    RelativeTime,
  },
  props: {
    brandImgUrl: {
      type: String,
      default: '',
    },
    brandUrl: {
      type: String,
      default: '',
    },
    eventBaseHref: {
      type: String,
      default: '',
    },
    openEventsInNewWindow: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      nextToPlay: 'NextToPlay/getData',
    }),
  },
  methods: {
    startDateTime: function(startTime) {
      return Moment.unix(startTime).format(TIME_FORMAT);
    },
    endDateTime: function(startTime) {
      return Moment.unix(startTime)
        .add(1, 'hours')
        .format(TIME_FORMAT);
    },
  },
  getSSRActions() {
    return [
      {
        name: 'NextToPlay/fetchNextToPlay',
      },
    ];
  },
};
</script>

<template>
  <div class="next-to-play-square">
    <!-- Header -->
    <div class="square-header">
      <h3 class="square-header__title">{{ nextToPlay.componentTitle }}</h3>
      <div v-if="brandImgUrl && !brandUrl">
        <img :src="brandImgUrl">
      </div>
      <div v-if="brandImgUrl && brandUrl">
        <a :href="brandUrl" target="_blank"><img :src="brandImgUrl"></a>
      </div>
    </div>

    <!-- Main -->
    <div class="square-main">
      <div class="square-row__wrap js-square-row-wrap">
        <div v-if="nextToPlay.sports" class="square-row__group">
          <a v-for="event in nextToPlay.sports.events"
             :href="`${eventBaseHref}${event.eventURL}`"
             :key="event.eventId"
             :title="event.eventTitle"
             :target="openEventsInNewWindow ? '_blank' : ''"
             class="square-row"
             itemscope
             itemtype="http://schema.org/SportsEvent"
          >
            <meta :content="'https://www.odds.com.au/sport' + event.eventURL" itemprop="url" >
            <meta :content="startDateTime(event.startTime)" itemprop="startDate" >
            <meta :content="endDateTime(event.startTime)" itemprop="endDate" >
            <div class="square-row__event">
              <span class="square-row__sport-icon" v-html="event.sportIcon"></span>
              <span class="square-row__event-text" itemprop="name">{{ event.eventTitle }}</span>
            </div>
            <meta :content="event.sportName + ' - ' + event.eventTitle" itemprop="description" >
            <span itemprop="location" itemscope itemtype="http://schema.org/Place">
              <meta :content="event.sportName" itemprop="name" >
              <span itemprop="address" itemscope itemtype="http://schema.org/PostalAddress">
                <meta :content="event.venueName" itemprop="name" >
              </span>
            </span>
            <RelativeTime :target-time="event.startTime"/>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
